import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import SearchedFact from "../../component/factList/SearchedFact";
import { useEffect } from "react";

const SearchedFactWrapper = () => {
	const { type } = useParams<{ type: "my" | "interest" | "recent" }>();
	const [searchParams] = useSearchParams();
	const keyword = searchParams.get("keyword") || "";
	const navigate = useNavigate();

	useEffect(() => {
		// ✅ my, interest 타입은 로그인 필요
		const isLoggedIn = !!localStorage.getItem("accessToken");
		if ((type === "my" || type === "interest") && !isLoggedIn) {
			alert("로그인이 필요한 기능입니다.");
			navigate("/login");
		}
	}, [type, navigate]);

	if (!type) return <div>잘못된 검색 경로입니다.</div>;

	return <SearchedFact keyword={keyword} type={type} />;
};

export default SearchedFactWrapper;
